import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import Footer from "./components/footer";
import HeroSection from "./components/HeroSection";
import OurExpertise from "./components/OurExpertise";
import MissionVision from "./components/aboutUs";
import ContactSection from "./components/contactus";
import VRM from "./components/Vrm";

// Pages
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import EduSquarePage from "./pages/EduSquarePage";

const Home = () => (
  <>
    <HeroSection />
    <OurExpertise />
    <VRM />
    <MissionVision />
    <ContactSection />
  </>
);

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refund_policy" element={<RefundPolicyPage />} />
        <Route path="/edu-square" element={<EduSquarePage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
